export default __webpack_public_path__ + "static/media/number-2.41b679d2.svg";